import React, { useEffect, useState } from 'react';
import './TOMi8versions.css';
import { create_new_version, deploy_update, get_models, get_projects, getPackages, getPackageVersion, get_ssl_cert_info, upload_ssl_cert } from '../../utils/services';
import {  useNavigate } from 'react-router-dom';
import Modal_proyectos from '../menus/Modal';
import Select from "react-select";

function TOMi8versions  ({permission}) {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const [isModalOpen, setModalOpen] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]); // Estado para las opciones del dropdown
  const [versions, setVersions] = useState([]);
  const [VersionsCombo, setVersionsCombo] = useState([]);
  const [file, setFile] = useState(null);
  const [fileEN, setENFile] = useState(null);
  const [fileES, setESFile] = useState(null);
  const [fileAR, setARFile] = useState(null);
  const [filePT, setPTFile] = useState(null);
  const [filevideoBanner, setfilevideoBanner] = useState(null);
  const [version2deploy, setversion2deploy] = useState(0);
  const [selectedProject, setselectedProject] = useState(0);
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedCapacity, setselectedCapacity] = useState("");
  const [selectedPackagename, setSelectedPackage] = useState("");
    const [projects, setprojects] = useState([]);
    
      const [modelsListOpt, setModelsListOpt] = useState([]); // Estado para las opciones del dropdown
    
    // SSL Certificate states
    const [sslInfo, setSslInfo] = useState(null);
    const [sslLoading, setSslLoading] = useState(true);
    const [sslModalOpen, setSslModalOpen] = useState(false);
    const [sslFile, setSslFile] = useState(null);
    const [sslExpirationDate, setSslExpirationDate] = useState('');
    const [sslUploading, setSslUploading] = useState(false);

  const [newVersion, setNewVersion] = useState({
    versionCode: '',
    versionName: '',
    fechaPublish: '',
    comments: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewVersion((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {

      setFile ( e.target.files[0]);
    console.log('Selected file:', file);
  
  };

  
  const handleindexFileChange = (e, lang) => {
    console.log("idiomas" , e.target.files[0].name, lang);
    switch (lang){
      case "en":
        setENFile(e.target.files[0]);
        break;
      case "es":
        setESFile(e.target.files[0]);
        break;
      case "ar":
        setARFile(e.target.files[0]);
        break;
      case "pt":
        setPTFile(e.target.files[0]);
        break;
      case "vid":
        setfilevideoBanner(e.target.files[0]);
        break;

    }

};


  const addVersion = () => {
    
    if (selectedPackagename === ""){
      alert("Debe seleccionar un paquete al cual se asocia la actualización");
      return;
    }

    if (file === "" || newVersion.comments === "" || newVersion.versionCode === "" || newVersion.versionName === ""){
      alert("Debe completar todos los datos");
      return;
    }

    async function fetchAddVersion() {
      const packageslist = await create_new_version(token, selectedPackagename , file, newVersion.comments, newVersion.versionCode, newVersion.versionName, fileEN,fileES,fileAR,filePT, filevideoBanner);
      if (packageslist==="INVALID"){
        navigate("/");
      }else{
        
        refreshlist(selectedPackagename);
        setModalOpen(false);
        
     }
    }

    fetchAddVersion();

  };



  useEffect(() => {

    async function fetchPackages() {
      const packageslist = await getPackages(token);
      if (packageslist==="INVALID"){
        navigate("/");
      }else{

        console.log("Lista: " + packageslist[0].package_name);
        
        const packageNames = packageslist.map(element => element.package_name);
        packageNames.unshift("Select one...");
        setDropdownOptions(packageNames);
        
     }
    }

    fetchPackages();
    fetchSslInfo();
    if (permission ==="1") 
      { 
        refresh_projects_list();
        fetchgetModels();
      }
  }, [token]); // Solo se vuelve a ejecutar si 'token' cambia


  const refresh_projects_list = () => {
      async function fetchProjects() {
          const membersList = await get_projects(token);
          if (membersList==="INVALID"){
            navigate("/");
          }else{
            const members = membersList
            .filter(element => element.t8s>0)
            .map((element, index) => {
              return {id:element.id, label: element.project_name + " ( " +  element.t8s + " Unds)", value: element.project_id,   index: index };
            });

            members.unshift(
              {
                id:0,
                label: "Todos",
                value:""
              }
            )

            setprojects(members);
                    
         }
        }
        fetchProjects();
    }


  const refreshlist = (packageName) =>{

    async function fetchVersions(packageName) {
      const packageVersionlist = await getPackageVersion(token, packageName);
      if (packageVersionlist==="INVALID"){
        navigate("/");
      }else{
        try{
          const newVersions = packageVersionlist.map(item => ({
            versionCode: item.version,
            versionName: item.version_name,
            fechaPublish: item.release_date,
            comments: item.description,
            url: item.url,
            info_url: item.info_url,
          }));
          const newVersionsCombo = packageVersionlist.map(item => ({
            versionCode: item.version,
            versionName: item.version_name,
          }));
          newVersionsCombo.unshift({
            versionCode: 0,
            versionName: " (Ninguno)",
          });

          setVersions(newVersions);
          setVersionsCombo(newVersionsCombo);
        }catch (err) {
          
        }

        
     }
    }
    fetchVersions(packageName);

  }


  
    async function fetchgetModels() {
      const modelsList = await get_models(token);
      if (modelsList==="INVALID"){
        navigate("/");
      }else{
        const modelsNames = modelsList.map(element => element.reference);
        modelsNames.unshift("Todos");
        setModelsListOpt(modelsNames);
        
     }
    }

  // SSL Certificate functions
  const fetchSslInfo = async () => {
    setSslLoading(true);
    try {
      const result = await get_ssl_cert_info(token);
      if (result === "INVALID") {
        navigate("/");
      } else {
        setSslInfo(result);
      }
    } catch (err) {
      console.error("Error fetching SSL info:", err);
      setSslInfo(null);
    } finally {
      setSslLoading(false);
    }
  };

  const handleSslUpload = async () => {
    if (!sslFile) {
      alert("Debe seleccionar un archivo de certificado (.p12)");
      return;
    }
    if (!sslExpirationDate) {
      alert("Debe indicar la fecha de vencimiento del certificado");
      return;
    }

    setSslUploading(true);
    try {
      const result = await upload_ssl_cert(token, sslFile, sslExpirationDate);
      if (result === "INVALID") {
        navigate("/");
      } else if (result && result.status === 'ok') {
        alert("Certificado subido correctamente");
        setSslModalOpen(false);
        setSslFile(null);
        setSslExpirationDate('');
        fetchSslInfo();
      } else {
        alert(result?.message || "Error al subir el certificado");
      }
    } catch (err) {
      console.error("Error uploading SSL cert:", err);
      alert("Error al subir el certificado");
    } finally {
      setSslUploading(false);
    }
  };

  const getExpirationStyle = (dateStr) => {
    if (!dateStr) return {};
    const expDate = new Date(dateStr);
    const now = new Date();
    const diffDays = Math.ceil((expDate - now) / (1000 * 60 * 60 * 24));
    if (diffDays < 0) return { color: '#dc3545', fontWeight: 'bold' }; // Expirado - rojo
    if (diffDays <= 30) return { color: '#fd7e14', fontWeight: 'bold' }; // Próximo a expirar - naranja
    return { color: '#198754', fontWeight: 'bold' }; // Vigente - verde
  };

  const getExpirationLabel = (dateStr) => {
    if (!dateStr) return '';
    const expDate = new Date(dateStr);
    const now = new Date();
    const diffDays = Math.ceil((expDate - now) / (1000 * 60 * 60 * 24));
    if (diffDays < 0) return ` (Expirado hace ${Math.abs(diffDays)} días)`;
    if (diffDays === 0) return ' (Expira hoy)';
    if (diffDays <= 30) return ` (Expira en ${diffDays} días)`;
    return ` (Vigente - ${diffDays} días restantes)`;
  };

  const deployUpdate = () =>{
    console.log("Deploy Updt", version2deploy, selectedProject, selectedCapacity, selectedModel);

    if (window.confirm("¿Estás seguro de actualizar los TOMi8 que complan con: "
                        + "\n proyecto: " + selectedProject 
                        + "\n capacidad: " + selectedCapacity 
                        + "\n con modelo: " + selectedModel
                        + "\n a la version ***** " + version2deploy
                        + " ***** del paquete ---->>>>>" + selectedPackagename

    )) {
      fetchDeployUpdate();
    }
    
    async function fetchDeployUpdate () {
      const modelsList = await deploy_update(token, selectedProject, selectedCapacity, selectedModel, version2deploy, selectedPackagename);
      if (modelsList==="INVALID"){
        navigate("/");
      }else{
        const modelsNames = modelsList.map(element => element.reference);
        modelsNames.unshift("Todos");
        setModelsListOpt(modelsNames);
        
     }
    }
  }

  const handleDropdownChange = (e) => {

    refreshlist(e.target.value);
    setSelectedPackage(e.target.value);
  };

  return (
   <div className="gobal p-3 p-md-4">
    
      {/* Se añade un margen inferior para separar esta sección de la tabla */}
      <div className="containerVersions mb-4">
      
        {/* Se usa flexbox para alinear los elementos en la misma línea de forma segura */}
        <div className="dropdown d-flex align-items-center gap-3">
        
          {/* Se añade la clase de Bootstrap al select, MANTENIENDO la clase original */}
          <select className="dropdown-select form-select" onChange={handleDropdownChange}>
             {dropdownOptions.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
          
          {permission === "1" && (
            // Se añaden clases de Bootstrap al botón, MANTENIENDO la clase original
            <button onClick={() => setModalOpen(true)} className="add-button btn btn-primary flex-shrink-0">
              Subir nueva version
            </button>
          )}
        </div>
      </div>

      {/* Se añade un div con la clase "table-responsive" para que la tabla no rompa el diseño en móviles */}
      <div className="table-container table-responsive">
        {/* Se añaden clases de Bootstrap a la tabla, MANTENIENDO la clase original */}
        <table className="version-table table table-striped table-hover">
          <thead>
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Date</th>
              <th>Comments</th>
              <th>url</th>
              <th>info-es</th>
              <th>info-en</th>
              <th>info-pt</th>
              <th>info-ar</th>
            </tr>
          </thead>
          <tbody>
            {versions.map((version, index) => (
              <tr key={index}>
                {/* NOTA: He mantenido tus anchos fijos para no alterar nada. 
                    Para una mejor responsividad, lo ideal sería eliminarlos en el futuro. */}
                <td style={{ width: '5%' }}>{version.versionCode}</td>
                <td style={{ width: '5%' }}>{version.versionName}</td>
                <td style={{ width: '10%' }}>{version.fechaPublish}</td>
                <td style={{ width: '55%', whiteSpace: "pre-line" }}>{version.comments}</td>
                <td style={{ width: '5%' }}><a href={version.url} target="_blank" rel="noopener noreferrer">APK</a></td>
                <td style={{ width: '5%' }}><a href={version.info_url+"/index-es.html"} target="_blank" rel="noopener noreferrer">index-es</a></td>
                <td style={{ width: '5%' }}><a href={version.info_url+"/index-en.html"} target="_blank" rel="noopener noreferrer">index-en</a></td>
                <td style={{ width: '5%' }}><a href={version.info_url+"/index-pt.html"} target="_blank" rel="noopener noreferrer">index-pt</a></td>
                <td style={{ width: '5%' }}><a href={version.info_url+"/index-ar.html"} target="_blank" rel="noopener noreferrer">index-ar</a></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Tu modal no se toca, ya que usa clases de Bootstrap internamente y funciona bien. */}
      <Modal_proyectos title="Nueva Versión de Proyecto" isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
      <div className="modal-body">
            <form>
              {/* Campo de Comentarios */}
              <div className="mb-3">
                <label htmlFor="comments" className="form-label">Comentarios:</label>
                <textarea
                  id="comments"
                  name="comments"
                  value={newVersion.comments}
                  onChange={handleInputChange}
                  className="form-control"
                  rows="3"
                  placeholder="Describe los cambios, mejoras o correcciones de esta versión..."
                ></textarea>
              </div>

              {/* Campos de Código de Versión y Nombre de Versión en una fila */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="versionCode" className="form-label">Código de Versión:</label>
                  <input
                    type="text"
                    id="versionCode"
                    name="versionCode"
                    value={newVersion.versionCode}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Ej: 10 (numérico)"
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="versionName" className="form-label">Nombre de Versión:</label>
                  <input
                    type="text"
                    id="versionName"
                    name="versionName"
                    value={newVersion.versionName}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Ej: 1.0.0 (semántico)"
                  />
                </div>
              </div>

              {/* Campo de Paquete (APK) */}
              <div className="mb-3">
                <label htmlFor="packageFile" className="form-label">Paquete (APK):</label>
                <input
                  type="file"
                  id="packageFile"
                  onChange={handleFileChange}
                  className="form-control"
                  accept=".apk"
                />
                <div className="form-text">Solo se permiten archivos .apk para la aplicación Android.</div>
              </div>

              <hr className="my-4" /> {/* Separador visual */}

              {/* Sección de Archivos de Índice (HTML) */}
              <h6 className="mb-3">Archivos de Índice (Páginas Web):</h6>
              <div className="mb-3">
                <label htmlFor="indexEs" className="form-label">Índice (Español):</label>
                <input
                  type="file"
                  id="indexEs"
                  onChange={(e) => handleindexFileChange(e, "es")}
                  className="form-control"
                  accept=".html, .htm"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="indexEn" className="form-label">Índice (Inglés):</label>
                <input
                  type="file"
                  id="indexEn"
                  onChange={(e) => handleindexFileChange(e, "en")}
                  className="form-control"
                  accept=".html, .htm"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="indexAr" className="form-label">Índice (Árabe):</label>
                <input
                  type="file"
                  id="indexAr"
                  onChange={(e) => handleindexFileChange(e, "ar")}
                  className="form-control"
                  accept=".html, .htm"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="indexPt" className="form-label">Índice (Portugués):</label>
                <input
                  type="file"
                  id="indexPt"
                  onChange={(e) => handleindexFileChange(e, "pt")}
                  className="form-control"
                  accept=".html, .htm"
                />
              </div>

              <hr className="my-4" /> {/* Separador visual */}

              {/* Campo de Video Banner */}
              <div className="mb-3">
                <label htmlFor="videoBanner" className="form-label">Video Banner:</label>
                <input
                  type="file"
                  id="videoBanner"
                  onChange={(e) => handleindexFileChange(e, "vid")}
                  className="form-control"
                  accept=".mp4"
                />
                <div className="form-text">Solo se permiten archivos .mp4 para el banner de video.</div>
              </div>
            </form>
          </div>

          {/* Pie del Modal */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalOpen(false)}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={addVersion}
            >
              Agregar Versión
            </button>
          </div>
      </Modal_proyectos>

      {/* SSL Certificate Info Card */}
      <div className="card mt-4 shadow-sm">
        <div className="card-body p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">
              <i className="bi bi-shield-lock me-2"></i>
              Certificado SSL (keystore_legacy.p12)
            </h5>
            {permission === "1" && (
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setSslModalOpen(true)}
              >
                <i className="bi bi-upload me-1"></i>
                Subir nuevo certificado
              </button>
            )}
          </div>
          <hr />
          {sslLoading ? (
            <div className="text-center py-3">
              <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
              Consultando información del certificado...
            </div>
          ) : sslInfo && sslInfo.exists ? (
            <div>
              <div className="row">
                <div className="col-md-4">
                  <strong>Fecha de vencimiento:</strong>
                </div>
                <div className="col-md-8">
                  <span style={getExpirationStyle(sslInfo.expiration_date)}>
                    {sslInfo.expiration_date}
                    {getExpirationLabel(sslInfo.expiration_date)}
                  </span>
                </div>
              </div>
              {sslInfo.uploaded_by && (
                <div className="row mt-2">
                  <div className="col-md-4">
                    <strong>Subido por:</strong>
                  </div>
                  <div className="col-md-8">{sslInfo.uploaded_by}</div>
                </div>
              )}
              {sslInfo.uploaded_at && (
                <div className="row mt-2">
                  <div className="col-md-4">
                    <strong>Fecha de carga:</strong>
                  </div>
                  <div className="col-md-8">{sslInfo.uploaded_at}</div>
                </div>
              )}
            </div>
          ) : (
            <div className="alert alert-warning mb-0">
              <i className="bi bi-exclamation-triangle me-2"></i>
              No hay ningún certificado disponible
            </div>
          )}
        </div>
      </div>

      {/* SSL Upload Modal */}
      <Modal_proyectos title="Subir Certificado SSL" isOpen={sslModalOpen} onClose={() => setSslModalOpen(false)}>
        <div className="modal-body">
          <form>
            <div className="mb-3">
              <label htmlFor="sslCertFile" className="form-label">Archivo de certificado (.p12):</label>
              <input
                type="file"
                id="sslCertFile"
                onChange={(e) => setSslFile(e.target.files[0])}
                className="form-control"
                accept=".p12,.pfx"
              />
              <div className="form-text">Seleccione el archivo keystore_legacy.p12</div>
            </div>
            <div className="mb-3">
              <label htmlFor="sslExpDate" className="form-label">Fecha de vencimiento del certificado:</label>
              <input
                type="date"
                id="sslExpDate"
                value={sslExpirationDate}
                onChange={(e) => setSslExpirationDate(e.target.value)}
                className="form-control"
              />
              <div className="form-text">Indique la fecha en la que expira el certificado SSL.</div>
            </div>
          </form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => { setSslModalOpen(false); setSslFile(null); setSslExpirationDate(''); }}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSslUpload}
            disabled={sslUploading}
          >
            {sslUploading ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Subiendo...
              </>
            ) : (
              'Subir certificado'
            )}
          </button>
        </div>
      </Modal_proyectos>

      { selectedPackagename !== "" && permission === "1" && (
        // Tu div ya tiene la clase "card", lo cual es perfecto. Le añadimos espaciado y sombra.
        <div className="card mt-4 shadow-sm">
          {/* Se añade la clase card-body para un padding interno correcto */}
          <div className="card-body p-4">
            <label className="title h5 mb-3 d-block"> {/* Se convierte el label en un título de bloque */}
              Desplegar {selectedPackagename} versión:  
              {/* Se añade la clase de Bootstrap al select */}
              <select className="form-select mt-2" onChange={(e) => setversion2deploy(e.target.value)}>
                {VersionsCombo.map((option, index) => (
                  <option key={index} value={option.versionCode}>
                    {option.versionCode + " (v" + option.versionName + ")"}
                  </option>
                ))}
              </select>
            </label>

            {/* Se usa el sistema de rejilla de Bootstrap para alinear los campos */}
            <div className="section mb-3">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <label className="label form-label">Que pertenezcan al proyecto:</label>
                </div>
                <div className="col-md-8">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={projects}
                    onChange={(selectedOption) => setselectedProject(selectedOption.value)}
                    placeholder="Buscar producto..."
                    isSearchable
                  />
                </div>
              </div>
            </div>

            <div className="section mb-3">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <label className="label form-label">Según su capacidad y modelo:</label>
                </div>
                {/* Se usa un input-group para unir los dos selects */}
                <div className="col-md-8 input-group">
                  <select className="select form-select" onChange={(e) => setselectedCapacity(e.target.value)}>
                    <option value="">Todas</option>
                    <option value="TLT">TLT (64)</option>
                    <option value="T128">T128</option>
                    <option value="T256">T256</option>
                    <option value="T512">T512</option>
                    <option value="T1TB">T1TB</option>
                  </select>
                  <select className="dropdown-select form-select" onChange={(e) => setSelectedModel(e.target.value)}>
                    {modelsListOpt.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <hr />

            <div className="button-container d-flex justify-content-end align-items-center gap-3 mt-3">
              <a href='https://lookerstudio.google.com/...' target="_blank" rel="noopener noreferrer">Dashboard de despliegue</a>
              <button className="button-yellow btn btn-warning" onClick={() => deployUpdate()}>Enviar actualización</button>
            </div>
          </div>
        </div>
      )}
    </div>

  );
};

export default TOMi8versions;
